import React, { useState, useEffect } from "react";
import TestimonialCard from "./TestimonialCard";
import styles from "../styles/TestimonialSection.module.css";
import userImage from "@assets/placeholder.png";
import avatar2 from "@assets/home2/featured/cover3-1.webp"
import arrow_left from "@assets/home2/featured/arrow_left.svg"
import arrow_right from "@assets/home2/featured/arrow_right.svg"
import avatar3 from "@assets/home2/featured/thumb12-1.webp"
import avatar4 from "@assets/home2/featured/cover3-3.webp"
import avatar5 from "@assets/activity/4.webp"


const testimonials = [
  {
    image: userImage,
    name: "Emily R",
    role: "Artist",
    testimonial: "The images are CONSISTENT. Super easy to use. I don't have to make multiple requests to get the same style nor image. My prompts are literally lines from my script. I created my first episode for webcomic in less than half a day. This is a game-changer for me!",
  },
  {
    image: avatar2,
    name: "David K",
    role: "Comic Creator",
    testimonial: "I was blown away by the image quality of content on UE Comix. The stories you can create are insane. I've never seen anything like it!",
  },
  {
    image: avatar3,
    name: "Chris H",
    role: "Writer",
    testimonial: "UE Comix has given me a platform to embrace my ideas and connect with like-minded individuals. The AI features and tools are top-notch, and the team is always listening to feedback. I'm so glad I joined this community!",
  },
  {
    image: avatar4,
    name: "Kendo G.",
    role: "Mangaka",
    testimonial: "I was skeptical at first, but the platform has genuinely helped me. I can easily create a storyboard for my manga in minutes. And the AI tools are amazing. Thank you, UE Comix!",
  },
  {
    image: avatar5,
    name: "James D",
    role: "Creator",
    testimonial: "UE Comix is more than just a platform – it's a movement. It's a space where creativity knows no bounds, and people can come together to share their passions. I'm honored to be a part of this community!",
  },

  
];
const TestimonialSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [progressBarStyle, setProgressBarStyle] = useState({ width: '0', transform: 'translateX(0)' });

  const handlePrevClick = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const handleNextClick = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const updateProgressBar = () => {
    const navDots = document.querySelectorAll(`.${styles.navDot}`);
    if (navDots.length > 0) {
      const firstDot = navDots[0];
      const dotWidth = firstDot.offsetWidth + parseFloat(window.getComputedStyle(firstDot).marginRight) * 2;
      const progressBarWidth = dotWidth; // Fixed width for the progress bar
      const progressBarTranslate = dotWidth * currentIndex;

      setProgressBarStyle({
        width: `${progressBarWidth}px`,
        transform: `translateX(${progressBarTranslate}px)`
      });
    }
  };

  useEffect(() => {
    updateProgressBar();
    window.addEventListener('resize', updateProgressBar);
    return () => window.removeEventListener('resize', updateProgressBar);
  }, [currentIndex]);

  const visibleTestimonials = [
    testimonials[(currentIndex - 1 + testimonials.length) % testimonials.length],
    testimonials[currentIndex],
    testimonials[(currentIndex + 1) % testimonials.length],
  ];

  return (
    <section className={styles.testimonialSection}>
      <h2 className={styles.sectionTitle}>Testimonials</h2>
      <div className={styles.testimonialGrid}>
        {visibleTestimonials.map((testimonial, index) => {
          let className = styles.testimonialCard;

          if (index === 0) {
            className = `${styles.testimonialCard} ${styles.left}`;
          } else if (index === 1) {
            className = `${styles.testimonialCard} ${styles.center}`;
          } else if (index === 2) {
            className = `${styles.testimonialCard} ${styles.right}`;
          }

          return (
            <div key={index} className={className}>
              <TestimonialCard {...testimonial} />
            </div>
          );
        })}
      </div>
      <nav className={styles.navigationBar}>
        <div className={styles.navigationControls}>
          <img
            src={arrow_left}
            alt="Previous"
            className={styles.icon}
            onClick={handlePrevClick}
          />
          <div className={styles.navDotsContainer}>
            {testimonials.map((_, index) => (
              <span
                key={index}
                className={`${styles.navDot} ${index === currentIndex ? styles.navDotActive : ""}`}
              />
            ))}
            <div
              className={styles.progressBar}
              style={progressBarStyle}
              role="progressbar"
              aria-valuenow={((currentIndex + 1) / testimonials.length) * 100}
              aria-valuemin="0"
              aria-valuemax="100"
            />
          </div>
	    <img
 	    src={arrow_right}
            alt="Next"
            className={styles.icon}
            onClick={handleNextClick}
          />
        </div>
      </nav>
    </section>
  );
};

export default TestimonialSection;
